<!-- Pug Template -->
<template lang="pug">
.stage-card.card.d-flex.w-100.p-5.py-4.text-white.align-items-center.text-center.rounded-lg(
	:style="style"
)
	h2.h1.text-white 0{{ stage.number }}. {{ stage.name }}
	
	.flex-grow-1.card-text(
		v-html="replaceVerticalText( stage.card_text, stage.topLevelVerticals )"
	)
	router-link.btn.btn-outline.btn-white.btn-lg.font-sans.btn-pill(
		:to="{name:'stage', params:{ stage_slug }}"
	) Explore {{ stage.name }}
		span.mdi.mdi-arrow-right.ml-2(
			style="font-size: inherit;"
		)

</template>

<!-- Script -->
<script>
import {replaceVerticalText} from './store';
export default {

	props: {
		stage: {
			type: Object,
			required: true
		}
	},

	data(){
		return {replaceVerticalText};
	},

	computed: {
		style(){
			return {
				"background-color": this.stage.backgroundColor
			};
		},
		stage_slug(){
			return this.stage.slug;
		}
	}
};
</script>

<!-- SCSS Style -->
<style lang="scss" scoped>
.stage-card {
	aspect-ratio: 2/1;
}
.card-text::v-deep a {
	color: #fff;
	text-decoration: underline;
	font-weight: bold;
}
</style>